









































import { Component, Vue } from "vue-property-decorator";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import { agentApi } from "@/getinfo-api";
import { Condition as ICondition } from "@/api-v2/agent/models/condition";
import TextField from "@/components/form/CustomPage/textField.vue";
import { i18n } from "@/locales/settings";
import { LocalesFields } from "@/locales/translateInterface";

@Component({
  components: { TextField, CBlock, CPage }
})
export default class ConditionView extends Vue {
  condition!: ICondition;
  isLoading: boolean = false;

  data() {
    return {
      condition: undefined
    };
  }

  get pageHeader() {
    return this.condition?.title
      ? this.condition?.title
      : this.$tc(this.$translate.PaymentTerms);
  }

  get breadcrumbs() {
    return [
      {
        to: { name: "conditionList" },
        label: i18n.tc(LocalesFields.PaymentTerms)
      },
      {
        label: this.condition?.title
      }
    ];
  }

  get conditionValue() {
    return this.condition?.percent
      ? `${this.condition?.value}%`
      : this.$converter.price(this.condition?.value);
  }

  async getCondition() {
    try {
      this.isLoading = true;
      const { data } = await agentApi.Condition.getCondition(
        this.$route.params.id
      );
      this.condition = data;
    } catch (e) {
      await this.$store.dispatch("errorException", {
        vm: this,
        error: e.response
      });
    } finally {
      this.isLoading = false;
    }
  }

  created() {
    this.getCondition();
  }
}
